import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { Container, Grid2 as Grid } from '@mui/material';
import config from '../../config';
import { FooterMenu } from '../FooterMenu/FooterMenu';
import LineAwesome from '../LineAwesome/LineAwesome';
import { Logger } from '../../core/logger/Logger';
import { meilisearchClient } from '../../core/search/meilisearch';
import { StrapiMenu } from '../../core/models/strapi-menu.model';
import { regionStore } from '../../store/jotai/store';
import { userAtom } from '../../store/jotai/atoms/user.atom';
import { SortOrder } from '../../constants/SortOrder';
import './Footer.scss';

const Footer = () => {
  const { t } = useTranslation();
  const [menus, setMenus] = useState<StrapiMenu[]>([]);
  const user = useAtomValue(userAtom, { store: regionStore });

  useEffect(() => {
    const loadMenus = async (): Promise<void> => {
      try {
        const result = await meilisearchClient.index('menu').search<StrapiMenu>('', {
          sort: [`${SortOrder.sortOrderAsc}`],
          limit: 100
        });

        setMenus(result.hits);
      } catch (error) {
        Logger.error(error);
      }
    };

    loadMenus();
  }, []);

  const becomeVendorLink =
    user && user.vendors && user.vendors.length > 0
      ? '/myaccount/vendorregistration'
      : '/händler-anmeldung';

  return (
    <>
      <section className='top-footer-section'>
        <Container>
          <Grid container className='top-footer'>
            <Grid size={12}>
              <h5 className='top-footer-title'>{t('footer.slogan')}</h5>
            </Grid>
          </Grid>
        </Container>
      </section>
      <section className='footer footer-main'>
        <Container>
          <Grid container>
            <Grid size={{ xs: 12, md: 4 }} className='reg-text'>
              {!user && (
                <>
                  <p className='link-p'>
                    <Link to='/register'>
                      {t('footer.register')}{' '}
                      <LineAwesome icon='arrow-alt-circle-right' className='footer-arrow' />
                    </Link>
                  </p>
                  <p>{t('footer.registerInfo')}</p>
                </>
              )}
              <br />
              {!user?.vendors?.length && (
                <p className='link-p'>
                  <Link to={becomeVendorLink}>
                    {t('footer.becomeVendor')}{' '}
                    <LineAwesome icon='arrow-alt-circle-right' className='footer-arrow' />
                  </Link>
                </p>
              )}
              <p>
                <span className='follow-us'>
                  <b>{t('footer.followUs')}</b>
                </span>
                <br />
                <a
                  href='https://www.facebook.com/regionimnetz'
                  target='_blank'
                  className='social-link'
                  rel='noreferrer'>
                  <LineAwesome icon='facebook' iconStyle='lab' />
                </a>
                <a
                  href='https://www.instagram.com/region_im_netz/'
                  target='_blank'
                  className='social-link'
                  rel='noreferrer'>
                  <LineAwesome icon='instagram' iconStyle='lab' />
                </a>
              </p>
            </Grid>
            <Grid size={{ sm: 6, md: 1 }} className='mobile-none' />
            {menus.map((item: StrapiMenu) => (
              <FooterMenu key={item.id} title={item.title} menuPages={item.menu_pages} />
            ))}
          </Grid>
        </Container>
        <p className='footer-copyright'>
          {t('footer.copyright', {
            year: new Date().getFullYear(),
            projectName: config.projectName
          })}
        </p>
      </section>
    </>
  );
};

export default Footer;
